import React from "react";
import { Button, Dropdown, Input } from "semantic-ui-react";
import DateTextBox from "react-lib/apps/common/DateTextBox";

type CreditFilterProps = {
  keyword: string;
  onKeywordChange: (value: string) => void;
  creditType: string;
  onCreditTypeChange: (value: string) => void;
  creditOptions: { key: string; text: string; value: string }[];
  dateFrom: string;
  onDateFromChange: (date: any) => void;
  dateTo: string;
  onDateToChange: (date: any) => void;
  onSearch: () => void;
  loading: boolean;
};

const MeHealthCreditUsageFilter = (props: CreditFilterProps) => (
  <div
    style={{
      display: "flex",
      gap: "12px",
      alignItems: "center",
      marginBottom: "20px",
      flexWrap: "wrap",
    }}
  >
    <Input
      icon={{ name: "search", link: false }}
      placeholder="Order No, Service"
      value={props.keyword}
      onChange={(e) => props.onKeywordChange(e.target.value)}
      style={{ minWidth: "220px" }}
    />
    <span style={{ color: "#a7a7a7" }}>Credit Use</span>
    <Dropdown
      selection
      options={props.creditOptions}
      value={props.creditType}
      onChange={(e, { value }) => props.onCreditTypeChange(String(value))}
      style={{ minWidth: "160px" }}
    />
    <span style={{ color: "#a7a7a7" }}>Trans. Date</span>
    <DateTextBox
      value={props.dateFrom}
      onChange={(date: any) => props.onDateFromChange(date)}
      placeholder="DD/MM/YYYY"
      inputStyle={{ width: "150px" }}
      setLanguage="th"
    />
    <DateTextBox
      value={props.dateTo}
      onChange={(date: any) => props.onDateToChange(date)}
      placeholder="DD/MM/YYYY"
      inputStyle={{ width: "150px" }}
      setLanguage="th"
    />
    <Button color="pink" onClick={props.onSearch} style={{ minWidth: "120px" }} loading={props.loading}>
      ค้นหา
    </Button>
  </div>
);

export default MeHealthCreditUsageFilter;
